// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/components/ui-list.scss
// module id = 33
// module chunks = 0